<template>
  <v-dialog v-model="show">
    <v-card class="py-1 px-2" v-if="saldoInsuficiente">
        <v-btn @click="$emit('close')" icon class="float">
            <v-icon color="blue darken-4">close</v-icon>
        </v-btn>
      <v-layout mx-3 align-center column text-center>
        <img width="45%" src="../../assets/icons/sad.png" />
      </v-layout>

      <v-card-title primary-title class = 'title headline justify-center' align ='center'>
          <b>Não há saldo disponível</b>
      </v-card-title>

      <v-card-text>
        <div class="text-left">
          Para continuar, adicione saldo na sua carteira ou escolha outra forma de pagamento
        </div>
        <v-spacer></v-spacer>
        <div class="total pa-1 text-left">
          <span >Saldo disponível: </span>
          <span>R$ {{saldoDisponivel}}</span>
        </div>
        <v-divider></v-divider>
        <div class="text-left">
          <span>Previsão de KM a pecorrer: </span>
          <span>R$ {{previsionPriceKM}}</span>
        </div>
        <v-divider></v-divider>
        <div class="text-left">
          <span>Valor da reserva: </span>
          <span>R$ {{pricePreview}}</span>
        </div>
        <div class="total pa-3 text-center">
          <img src="../../assets/icons/icon1large.png" />
          <span class="total pl-2 title">TOTAL:</span>
          <span class="total pl-1 title font-weight-regular">R$ {{totalPricePrevision}}</span>
        </div>

        
      </v-card-text>
      
      <v-card-actions>
        <v-btn large dark block color="green"
        @click="adicionarDinheiro">

         <span>ADICIONAR SALDO</span>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card  v-else>

      <v-btn @click="$emit('close')" icon class="float">
        <v-icon color="blue darken-4">close</v-icon>
      </v-btn>
      <br>
      <v-card-title class="title headline" align = 'center'>Valores a serem cobrados</v-card-title>
      <v-card-text>
        <div class="text-left">
          <span>Previsão de KM a pecorrer: </span>
          <span>R$ {{previsionPriceKM}}</span>
        </div>
        <div class="text-left">
          <span>Valor da reserva: </span>
          <span>R$ {{pricePreview}}</span>
        </div>
        <div class="total pa-3 text-center">
          <img src="../../assets/icons/icon1large.png" />
          <span class="total pl-2 title">TOTAL:</span>
          <span class="total pl-1 title font-weight-regular">R$ {{totalPricePrevision}}</span>
        </div>

        <div class="total pa-1 text-left">
          <span >Saldo disponível: </span>
          <span>R$ {{saldoDisponivel}}</span>
        </div>
      </v-card-text>
      <v-card-actions>
       
      <v-btn large dark block color="green"
        @click="$emit('confirma')">
         <span>CONFIRMA</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VehicleRequestController from "../../controllers/VehicleRequestController"
import WalletController from "../../controllers/WalletController"
import moment from "moment"

export default {
  data(){
      return{
        vehicleRequestController: new VehicleRequestController(this.$resource),
        walletController: new WalletController(this.$resource),
        saldoInsuficiente: true,
        previsionPriceKM: '0,00',
        totalPricePrevision: '0,00',
        saldoDisponivel: '0,00'
      }
  },

  async created(){
  },

  props: {
    show: {
      required: true,
      type: Boolean
    },
    pricePreview: {
      required: true,
      type: String
    },
    vehicleRequest: {
      type: Object,
      required: true
    }
  },
  watch: {
    show(value){
      if(value)
        this.verificaSaldo()
    }
  },

  methods:{
    adicionarDinheiro(){
      this.$router.push('/user/pagamento')
    },

    async verificaSaldo(){
      await this.vehicleRequestController.previsionPriceKM(this.vehicleRequest)
      .then(res => {
        this.previsionPriceKM = res.body.previsionPriceKM
      });
      let previsionPriceKM = Number.parseFloat(this.previsionPriceKM.replace(',', '.'));
      let pricePreview = Number.parseFloat(this.pricePreview.replace(',', '.'))
      let totalPricePrevision = previsionPriceKM + pricePreview;
      
      this.totalPricePrevision = totalPricePrevision.toFixed(2).replace('.', ',');

      await this.walletController.getSaldoDisponivelByUser()
      .then(res => {
        let money = res.saldoDisponivel / 100
        this.saldoDisponivel = money.toFixed(2).replace('.', ',');

        this.saldoInsuficiente = (money < totalPricePrevision)
      }
      , err => console.log(err))
      
      
    }
  }

};
</script>

<style scoped>
.float{
    position: absolute;
  top: 5px;
  right: 5px;
}

</style>